<template>
  <BasicButton
    :large="large"
    :small="small"
    :mini="mini"
    :snug="snug"
    :stopPropagation="stopPropagation"
    :disabled="disabled"
    @click="e => handleClick()"
  >
    <template v-if="product && !disabled">
      <PriceHandler
        :product="product"
        :adjustmentValue="adjustmentValue"
        inverted
        class="text--w-demi text--clr-white"
      />
      <span class="mx-8">&ndash;&#x202F;</span>
    </template>
    <span class="ecom-button__cta-block text--w-medium">
      <slot>{{ UI_ELEMENT("cta_add_to_cart") }} </slot>
    </span>
    <div
      class="ecom-button__confirm flex--col-center-center"
      :class="{
        'ecom-button__confirm--active':
          forceConfirmState || (isClicked && alertActive)
      }"
    >
      <span
        class="ecom-button__confirm-text text--clr-black"
        :class="[
          `text-commerce-button-primary${small || mini ? '-small' : ''}`,
          {
            'ecom-button__confirm-text--active':
              forceConfirmState || (isClicked && alertActive)
          }
        ]"
      >
        {{
          forceConfirmState
            ? UI_ELEMENT("ecom_confirm_already_in_cart")
            : small || mini
            ? UI_ELEMENT("ecom_confirm_add_to_cart_mini")
            : UI_ELEMENT("ecom_confirm_add_to_cart")
        }}
      </span>
    </div>
  </BasicButton>
</template>
<script>
import { formatPrice } from "../../utils"
import { mapGetters, mapState } from "vuex"
import { productTypes } from "../../store/constants"
import PriceHandler from "../text/PriceHandler.vue"

export default {
  name: "EcomButton",

  props: {
    product: Object,
    price: Object,
    compareAtPrice: Object,
    adjustmentValue: Number,
    large: Boolean,
    small: Boolean,
    mini: Boolean,
    snug: Boolean,
    stopPropagation: Boolean,
    disabled: Boolean,
    forceConfirmState: Boolean
  },

  components: {
    PriceHandler
  },

  data: () => ({
    isClicked: false
  }),

  methods: {
    formatPrice(price) {
      return formatPrice(price, this.$store.state.locale.localeConfig)
    },

    handleClick(evt) {
      this.isClicked = true
      this.$emit("click", evt)
    }
  },

  computed: {
    ...mapState("cart", ["alertActive"]),
    ...mapState("content", ["globalDiscount"]),
    ...mapGetters("content", ["GET_HAS_GLOBAL_PRICE_ADJUSTMENT"]),

    getHasPriceAdjustment() {
      return this.getDefaultPrice.cents > this.getAdjustedPrice.cents
    },

    getDefaultPrice() {
      if (this.compareAtPrice && this.compareAtPrice.cents > this.price.cents) {
        return this.compareAtPrice
      } else {
        return this.price
      }
    },

    getAdjustedPrice() {
      // TODO: The exclusion of Gift Cards here is a bit (well, a lot) hacky ///
      const _adjVal =
        (this.GET_HAS_GLOBAL_PRICE_ADJUSTMENT &&
          !(
            this.product && this.product.__typename == productTypes.GIFT_CARD
          ) &&
          this.globalDiscount.discountValue) ||
        this.adjustmentValue
      // The globally-applied adjustment, if it exists, takes precedence over any other adjustment value (altho ideally there should not be more than one)
      return _adjVal
        ? {
            ...this.price,
            cents: (this.price.cents * (100 - _adjVal)) / 100
          }
        : this.price
    }
  },

  watch: {
    alertActive(newVal) {
      if (!newVal && this.isClicked) this.isClicked = false
    }
  }
}
</script>
<style lang="scss">
.ecom-button {
  &__cta-block {
    display: inline-block;
  }

  &__confirm {
    pointer-events: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: getcolour(bleach_lime);
    opacity: 0;
    transition: opacity 0.2s linear 0.1s;

    &--active {
      transition: opacity 0.2s linear;
      opacity: 1;
    }
  }

  &__confirm-text {
    display: inline-block;
    opacity: 0;
    transition: opacity 0.1s linear;

    &--active {
      transition: opacity 0.1s linear 0.2s;
      opacity: 1;
    }
  }
}
</style>
